import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, intlShape } from 'react-intl';
import messages from '../../../data/common';

class ProductUnavailableComponent extends React.Component {
  availableStoresText({ availability }) {
    let availableCountriesText = '';
    const availableStores = availability.availableInStores;
    availableStores.forEach((store, index) => {
      const currentStore = store.countryCode.toUpperCase();
      if (index === 0) {
        availableCountriesText = currentStore;
      } else if (index < availableStores.length - 1) {
        availableCountriesText = `${availableCountriesText}, ${currentStore}`;
      } else {
        const separator = this.context.intl.formatMessage(messages.prepositionOr); // or
        availableCountriesText = `${availableCountriesText} ${separator} ${currentStore}`;
      }
    });
    return availableCountriesText;
  }

  render() {
    const whichStores = this.availableStoresText(this.props);
    const storesCount = this.props.availability.availableInStores.length;

    return (
      <div className="product-component-unavailable u-fontFamily-secondary">
        <div className="product-component-unavailable__text">
          <FormattedMessage
            id="app.products.list.unavailable.explanation"
            defaultMessage="Oops! This product is only available to order from our {whichStores} {storesCount, plural, one {store} other {stores}}."
            values={{ whichStores, storesCount }}
          />
        </div>
        <div className="product-component-unavailable__text">
          <span className="product-component-unavailable__text--highlight u-fontFamily-primaryMedium">
            <FormattedMessage
              id="app.products.list.unavailable.switchStore.title"
              defaultMessage="Switch your location"
            />
          </span>
          &nbsp;
          <FormattedMessage
            id="app.products.list.unavailable.switchStore.detail"
            defaultMessage="above to order and ship from {whichStores}."
            values={{ whichStores }}
          />
        </div>
      </div>
    );
  }
}

ProductUnavailableComponent.displayName = 'ProductUnavailable';

ProductUnavailableComponent.propTypes = {
  availability: PropTypes.shape({
    isAvailable: PropTypes.bool.isRequired,
    availableInStores: PropTypes.array.isRequired,
  }),
};

ProductUnavailableComponent.contextTypes = {
  intl: intlShape.isRequired,
};

export default ProductUnavailableComponent;
